// Mock data untuk IndoHukum.id Landing Page

export const profileData = {
  name: "IndoHukum.id",
  tagline: "Platform Pengetahuan Hukum Berbasis AI untuk Indonesia",
  description: "IndoHukum.id adalah platform inovatif yang menggabungkan keahlian hukum dengan teknologi AI untuk memberikan solusi hukum yang cepat, akurat, dan terpercaya bagi masyarakat Indonesia.",
  vision: "Menjadi platform terdepan dalam demokratisasi akses pengetahuan hukum di Indonesia melalui teknologi AI.",
  mission: [
    "Menyediakan informasi hukum yang akurat dan mudah diakses",
    "Membantu masyarakat memahami hak dan kewajiban hukum mereka",
    "Mendukung pembuatan kebijakan publik berbasis data dan AI",
    "Meningkatkan literasi hukum di Indonesia"
  ],
  contact: {
    address: "Gedung Graha Pratama Lt. 15, Jl. MT. Haryono Kav. 15, Jakarta Selatan 12810",
    email: "info@indohukum.id",
    phone: "+62 21 5790 3456",
    whatsapp: "+62 812 3456 7890"
  }
};

export const portfolioData = [
  {
    id: 1,
    title: "Analisis Peraturan Daerah Tentang Pajak Restoran",
    description: "Evaluasi komprehensif terhadap 50+ Perda di berbagai kota mengenai regulasi pajak restoran dan rekomendasi harmonisasi kebijakan.",
    year: "2024",
    category: "Hukum Administrasi Negara",
    client: "Kementerian Dalam Negeri"
  },
  {
    id: 2,
    title: "Policy Brief: Reformasi Hukum Perlindungan Data Pribadi",
    description: "Penyusunan policy brief untuk implementasi UU Perlindungan Data Pribadi dengan analisis komparatif GDPR dan regulasi negara ASEAN.",
    year: "2024",
    category: "Hukum Teknologi Informasi",
    client: "DPR RI"
  },
  {
    id: 3,
    title: "Evaluasi Peraturan Menteri Lingkungan Hidup",
    description: "Review menyeluruh terhadap 30+ Permen LHK terkait pengelolaan limbah industri dan rekomendasi perbaikan regulasi.",
    year: "2023",
    category: "Hukum Lingkungan",
    client: "Kementerian Lingkungan Hidup dan Kehutanan"
  },
  {
    id: 4,
    title: "Konsultasi Hukum Investasi Asing",
    description: "Pendampingan legal untuk 20+ investor asing dalam memahami regulasi investasi di Indonesia dan compliance requirements.",
    year: "2023",
    category: "Hukum Bisnis",
    client: "Asosiasi Pengusaha Indonesia"
  },
  {
    id: 5,
    title: "Analisis UU Cipta Kerja",
    description: "Kajian mendalam terhadap implikasi UU Cipta Kerja di sektor ketenagakerjaan dengan rekomendasi peraturan turunan.",
    year: "2023",
    category: "Hukum Ketenagakerjaan",
    client: "Kementerian Ketenagakerjaan"
  }
];

export const articlesData = [
  {
    id: 1,
    title: "Memahami UU Perlindungan Data Pribadi: Hak dan Kewajiban Anda",
    excerpt: "Panduan lengkap tentang hak-hak Anda sebagai pemilik data pribadi dan kewajiban perusahaan dalam melindungi data konsumen...",
    category: "Hukum Teknologi",
    author: "Tim IndoHukum",
    date: "15 Desember 2024",
    readTime: "8 menit",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800"
  },
  {
    id: 2,
    title: "5 Hal yang Perlu Diketahui Sebelum Membuat Perjanjian Kerja",
    excerpt: "Tips penting untuk pekerja dan pemberi kerja dalam menyusun perjanjian kerja yang adil dan sesuai regulasi...",
    category: "Hukum Ketenagakerjaan",
    author: "Tim IndoHukum",
    date: "10 Desember 2024",
    readTime: "6 menit",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800"
  },
  {
    id: 3,
    title: "Panduan Mendirikan PT di Indonesia: Proses dan Persyaratan",
    excerpt: "Langkah-langkah praktis mendirikan PT, mulai dari persiapan dokumen hingga pengurusan NPWP dan izin usaha...",
    category: "Hukum Bisnis",
    author: "Tim IndoHukum",
    date: "5 Desember 2024",
    readTime: "10 menit",
    image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=800"
  },
  {
    id: 4,
    title: "Hak Konsumen dalam Transaksi E-Commerce",
    excerpt: "Mengenal hak-hak Anda sebagai konsumen online dan cara mengajukan komplain yang efektif...",
    category: "Hukum Konsumen",
    author: "Tim IndoHukum",
    date: "1 Desember 2024",
    readTime: "7 menit",
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800"
  }
];

export const regulationsData = [
  {
    id: 1,
    number: "UU No. 27 Tahun 2022",
    title: "Perlindungan Data Pribadi",
    category: "Undang-Undang",
    year: "2022",
    summary: "Mengatur tentang perlindungan data pribadi dalam sistem elektronik"
  },
  {
    id: 2,
    number: "UU No. 6 Tahun 2023",
    title: "Penetapan Peraturan Pemerintah Pengganti Undang-Undang Nomor 2 Tahun 2022",
    category: "Undang-Undang",
    year: "2023",
    summary: "Tentang Cipta Kerja Menjadi Undang-Undang"
  },
  {
    id: 3,
    number: "PP No. 80 Tahun 2019",
    title: "Perdagangan Melalui Sistem Elektronik",
    category: "Peraturan Pemerintah",
    year: "2019",
    summary: "Mengatur tentang PMSE dan perlindungan konsumen dalam transaksi elektronik"
  },
  {
    id: 4,
    number: "Perpres No. 95 Tahun 2018",
    title: "Sistem Pemerintahan Berbasis Elektronik",
    category: "Peraturan Presiden",
    year: "2018",
    summary: "Pedoman pelaksanaan SPBE di instansi pemerintahan"
  }
];

export const hukumPediaFeatures = [
  {
    id: 1,
    title: "Chatbot Hukum AI",
    description: "Tanyakan pertanyaan hukum Anda dan dapatkan jawaban instan berbasis AI yang terlatih dengan ribuan regulasi Indonesia.",
    icon: "MessageSquare",
    color: "purple",
    action: "Mulai Konsultasi"
  },
  {
    id: 2,
    title: "Evaluasi Peraturan",
    description: "Upload dokumen peraturan dan dapatkan analisis komprehensif tentang kesesuaian, potensi masalah, dan rekomendasi perbaikan.",
    icon: "FileSearch",
    color: "blue",
    action: "Upload Peraturan"
  },
  {
    id: 3,
    title: "Policy Brief Generator",
    description: "Buat policy brief dan rumusan kebijakan profesional dengan bantuan AI dalam hitungan menit.",
    icon: "FileText",
    color: "orange",
    action: "Buat Policy Brief"
  }
];

export const teamData = [
  {
    name: "Dr. Ahmad Santoso, S.H., M.H.",
    position: "Founder & Legal Expert",
    expertise: "Hukum Tata Negara & Kebijakan Publik"
  },
  {
    name: "Sarah Wijaya, S.Kom., M.T.",
    position: "CTO",
    expertise: "AI & Machine Learning"
  },
  {
    name: "Prof. Budi Hartono, S.H., M.H., Ph.D.",
    position: "Legal Advisor",
    expertise: "Hukum Administrasi Negara"
  }
];
